// extracted by mini-css-extract-plugin
export default {"error":"styles_error__O6Wmp"};